var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
import * as _ from "lodash";
import { parse } from "query-string";
import moment from "moment";
import { WORKSPACE_ID } from "@ane/core/lib/constants/QueryString.constants";
import EnvironmentService from "@ane/core/lib/services/EnvironmentService";
import * as CollectionUtils from "@ane/core/lib/utils/CollectionUtils";
import { ROUTES } from "@ane/exp-data/lib/routes/Routes.constants";
import { getExperimentationGroupIdFromPath } from "@ane/exp-data/lib/utils/ManagementGroup/ManagementGroup.utils";
import { getLastCompletedPhase, getLastActivePhase } from "../MyActivities/MyActivitiesUtils.js";
import { EXPERIMENTATION_GROUP_URL_PARAM } from "../../Common/FeatureSearchConstants.js";
import { shouldRedirectToRolloutsRoute } from "@ane/exp-data/lib/routes/FeatureRolloutOptIn.utils";
import { FeatureRolloutRouteUtils } from "@ane/exp-data/lib/routes/FeatureRolloutRoute.utils";
const getOwnerValue = (searchQuery) => {
  if (!searchQuery) {
    return [];
  }
  const ownerRegEx = new RegExp("(\\s)*\\b(?:owner:)([A-Za-z0-9-]+)(\\s)*", "i");
  let queries = searchQuery.split(" ");
  let ownerValues = CollectionUtils.mapIfDefined(queries, (query) => {
    const querySplit = ownerRegEx.exec(query);
    const owner = !!querySplit && (querySplit == null ? void 0 : querySplit.length) >= 2 ? querySplit == null ? void 0 : querySplit[2] : null;
    if (!!owner) {
      return owner;
    }
  });
  return Array.from(new Set(ownerValues));
};
const getQueryValueWithoutOwner = (searchQuery) => {
  if (!searchQuery) {
    return "";
  }
  const ownerRegEx = new RegExp("(\\s)*\\b(?:owner:)([A-Za-z0-9-]+)(\\s)*", "i");
  let queryParts = [];
  let queries = searchQuery.split(" ");
  _.forEach(queries, (query) => {
    let queryString = query.replace(ownerRegEx, "");
    if (!!queryString) {
      queryParts.push(queryString);
    }
  });
  return queryParts.join(" ");
};
const getFeatureOrExperimentUrl = (data, rootExperimentationGroup) => {
  if (!!data.isLegacyExperiment) {
    return `${ROUTES.experiment.location.pathname}/${data.id}?${WORKSPACE_ID}=${data.workspaceId}`;
  }
  return getFeatureExperimentUrl({ id: data.id, workspaceId: data.workspaceId }, rootExperimentationGroup);
};
const getLegacyExperimentAlertsUrl = (data) => {
  return `${ROUTES.experiment.location.pathname}/${data.id}/alerts?${WORKSPACE_ID}=${data.workspaceId}`;
};
const getFeatureAlertsUrl = (data) => {
  return `/a/feature/id/analysis-results/${data.id}/alerts?${WORKSPACE_ID}=${data.workspaceId}`;
};
const getFeatureExperimentUrl = (data, rootExperimentationGroup) => {
  return shouldRedirectToRolloutsRoute(rootExperimentationGroup) && EnvironmentService.isUnifiedView ? FeatureRolloutRouteUtils.routes.view.getURL(data.id) : `${ROUTES.feature.location.pathname}/${data.id}?${WORKSPACE_ID}=${data.workspaceId}`;
};
const getExperimentUrl = (data, rootExperimentationGroup) => {
  if (data.IsFeatureRollout) {
    return getFeatureExperimentUrl({ id: data.Id, workspaceId: data.WorkspaceId }, rootExperimentationGroup);
  }
  return `${ROUTES.details.location.pathname}?id=${data.Id}&${WORKSPACE_ID}=${data.WorkspaceId}`;
};
const getFlightUrl = (flightName, mgmtGroup, workspaceId) => {
  let flightUrl = ROUTES.flightDetails.location.pathname;
  flightUrl = `${flightUrl}/${flightName}?managementGroup=${mgmtGroup}&${WORKSPACE_ID}=${workspaceId}`;
  return flightUrl;
};
const getAnalysisHubUrl = (stepId) => {
  return `/Analysis/Details?stepId=${stepId}`;
};
const generateAddress = (generateAddressParam) => {
  const defaultWorkspaceId = EnvironmentService.getWorkspaceIdOrDefault();
  const {
    searchQuery = "",
    fromDate = "Invalid date",
    toDate = "Invalid date",
    workspaceId = defaultWorkspaceId,
    managementGroup = "/",
    isolationGroup = "All",
    trafficFilters = ""
  } = generateAddressParam || {};
  const owner = getOwnerValue(searchQuery);
  const queryString = getQueryValueWithoutOwner(searchQuery);
  const workspaceUrl = `${WORKSPACE_ID}=${workspaceId || defaultWorkspaceId}&`;
  const mgmtUrl = managementGroup !== "/" && !!managementGroup ? `${!EnvironmentService.forceUnifiedView() ? "managementgroup" : EXPERIMENTATION_GROUP_URL_PARAM}=${managementGroup}&` : "";
  const isolationGrpUrl = isolationGroup !== "All" && !!isolationGroup ? `isolationgroup=${isolationGroup}&` : "";
  const trafficFiltersUrl = trafficFilters !== "" && !!trafficFilters ? `trafficfilters=${trafficFilters}&` : "";
  const ownerUrl = owner && !!owner ? generateOwners(owner) : "";
  const startedAfterUrl = !!fromDate && fromDate !== "Invalid date" ? `startedafter=${fromDate}&` : "";
  const startedBeforeUrl = !!toDate && toDate !== "Invalid date" ? `startedbefore=${toDate}&` : "";
  const queryStringUrl = !!queryString && queryString ? `q=${queryString}&` : "";
  const address = `?${workspaceUrl}${mgmtUrl}${isolationGrpUrl}${trafficFiltersUrl}${ownerUrl}${startedAfterUrl}${startedBeforeUrl}${queryStringUrl}${!EnvironmentService.forceUnifiedView() ? "CollapseRolloutTargetsIntoRoot=true" : ""}`;
  return address;
};
const generateOwners = (owners) => {
  let ownerValues = _.map(owners, (owner) => `owner=${owner}`).join("&");
  if (ownerValues !== "") {
    return ownerValues + "&";
  }
  return ownerValues;
};
const generateFlightSearchContext = (generateAddressParam) => {
  const {
    searchQuery = "",
    fromDate = "",
    toDate = "",
    managementGroup = "/",
    workspaceId = EnvironmentService.getWorkspaceIdOrDefault()
  } = generateAddressParam || {};
  const owner = getOwnerValue(searchQuery);
  const queryString = getQueryValueWithoutOwner(searchQuery);
  const startedAfter = !!fromDate && fromDate !== "Invalid date" ? `${fromDate}` : "";
  const startedBefore = !!toDate && toDate !== "Invalid date" ? `${toDate}` : "";
  return {
    workspaceId,
    managementgroup: managementGroup,
    owner: generateOwners(owner) || "",
    q: queryString || "",
    startedafter: startedAfter || "",
    startedbefore: startedBefore || ""
  };
};
const getStatusData = (phases) => {
  const activePhases = _.filter(phases, (p) => p.State !== "Completed" && p.State !== "New");
  const hasActivePhases = activePhases.length > 0;
  const lastActivePhase = hasActivePhases ? _.last(activePhases) : null;
  const upcomingPhase = _.find(phases, (p) => p.State === "New");
  let state = "";
  if (_.some(phases, (p) => p.State === "Running" || p.State === "RunningWithIssues")) {
    state = "Running";
  } else if (hasActivePhases && lastActivePhase.State === "StartRequested") {
    state = "Starting";
  } else if (hasActivePhases && lastActivePhase.State === "StopRequested") {
    state = "Stopping";
  } else if (_.every(phases, (p) => p.State === "Completed")) {
    state = "Completed";
  } else if (!hasActivePhases && !!upcomingPhase) {
    state = "New";
  } else {
    state = "Unknown";
  }
  return state;
};
const getCountofStatus = (phaseStatuses) => {
  return phaseStatuses.reduce((prev, cur) => {
    prev[cur] = (prev[cur] || 0) + 1;
    return prev;
  }, {});
};
const getUrlsForOtherSearchFieldsData = (searchExperiences, managementGroup, workspaceId) => {
  if (!searchExperiences) {
    return [];
  }
  const urls = searchExperiences.map((searchField) => {
    const { Data = {} } = searchField;
    if (!Data) {
      return "";
    }
    const { DataSources = {} } = Data;
    if (!DataSources) {
      return "";
    }
    if (Object.keys(DataSources).length <= 0) {
      return "";
    }
    const key = Object.keys(DataSources)[0];
    return DataSources[key].Url;
  });
  let uniqueUrls = _.uniq(urls);
  uniqueUrls = uniqueUrls.filter((u) => !!u);
  const experimentationGroup = getExperimentationGroupIdFromPath(workspaceId, managementGroup);
  const mdsDataplaneBaseUrl = EnvironmentService.endpoints.mds.url;
  return uniqueUrls.map((url) => {
    if (url.includes("/api/mds/") && url.match("/api/mds/(.*)\\?path")) {
      let section = url.match("/api/mds/(.*)\\?path")[1];
      section = section.split("/")[0];
      return `${mdsDataplaneBaseUrl}/workspaces/${workspaceId.toLowerCase()}/experimentationGroups/${experimentationGroup.toLowerCase()}/sections/${section}?apiversion=2019-11-01-preview`;
    }
    return url.replace("%managementgroup%", managementGroup).toLowerCase();
  });
};
const getSearchResultsColumnData = (searchResult, statusData) => {
  if (!searchResult) {
    return null;
  }
  const completedTime = calculateCompletedTime(searchResult, statusData);
  const startTime = calculateStartTime(searchResult, statusData);
  return __spreadProps(__spreadValues({}, searchResult), {
    experimentName: !!searchResult.Name ? searchResult.Name.toLowerCase() : "",
    experimentType: searchResult.IsFeatureRollout ? "Feature Rollout" : "Experiment",
    experimentStartedStr: moment(new Date(startTime)).format("MM/DD/YYYY"),
    experimentCreatedStr: moment(new Date(searchResult.Created)).format("MM/DD/YYYY"),
    experimentCompletedStr: completedTime ? moment(new Date(completedTime)).format("MM/DD/YYYY") : "",
    experimentStarted: new Date(startTime),
    experimentCreated: new Date(searchResult.Created),
    experimentCompleted: new Date(completedTime)
  });
};
const calculateCompletedTime = (data, statusData) => {
  var _a;
  if (!statusData) {
    return data.Created;
  }
  const searchStatusData = statusData[data.Id];
  return searchStatusData && searchStatusData.length && ((_a = getLastCompletedPhase(searchStatusData)) == null ? void 0 : _a.StopTime) || data.Completed;
};
const calculateStartTime = (data, runningStatusData) => {
  if (!runningStatusData) {
    return data.Created;
  }
  const statusData = runningStatusData[data.Id];
  let startTime;
  if (statusData && statusData.length) {
    startTime = getLastActivePhase(statusData).StartTime;
  } else {
    startTime = data.Created;
  }
  return startTime;
};
const getSearchResultsRows = (searchResults, statusData) => {
  return (searchResults || []).map((c) => getSearchResultsColumnData(c, statusData)).filter((s) => !!s);
};
const getText = (count) => count > 1 ? "Stages" : "Stage";
const getOwnersFromUrl = (locationSearch = document.location.search) => {
  var _a, _b;
  const queryparams = parse(locationSearch);
  const owner = queryparams.owner ? Array.isArray(queryparams.owner) ? (_b = _.map((_a = queryparams.owner) != null ? _a : [], (owner2) => `owner:${owner2}`).join(" ")) != null ? _b : [] : `owner:${queryparams.owner}` : "";
  return owner;
};
export {
  calculateCompletedTime,
  calculateStartTime,
  generateAddress,
  generateFlightSearchContext,
  generateOwners,
  getAnalysisHubUrl,
  getCountofStatus,
  getExperimentUrl,
  getFeatureAlertsUrl,
  getFeatureExperimentUrl,
  getFeatureOrExperimentUrl,
  getFlightUrl,
  getLegacyExperimentAlertsUrl,
  getOwnerValue,
  getOwnersFromUrl,
  getQueryValueWithoutOwner,
  getSearchResultsColumnData,
  getSearchResultsRows,
  getStatusData,
  getText,
  getUrlsForOtherSearchFieldsData
};
//# sourceMappingURL=ExperimentSearchUtil.js.map
